module.exports = __webpack_public_path__ + "static/img1-8d84eec6bd4dff6fc631d78f30fd1918.jpg";